export const updateExtension = () => {
  const event = document.createEvent('CustomEvent');
  if (event.initCustomEvent) {
    event.initCustomEvent('updateProjectList', true, true, null);
    document.dispatchEvent(event);
  }
};